<template>
  <order-list :orders="orders" :isShowPagination="total" :order-type="Number(type)"></order-list>
</template>

<script>
import OrderList from '@/pages/order/_list.vue';

export default {
  components: {
    OrderList,
  },
  data() {
    return {
      pageSize: 15,
      orders: undefined,
      total: undefined,
    };
  },
  computed: {
    type() {
      return this.$route.name === 'user-order-undelivered' ? 1 : 2;
    },
    page() {
      return this.$route.query.page || 1;
    },
  },
  watch: {
    $route: {
      handler: 'init',
      immediate: true,
    },
  },
  methods: {
    async init() {
      this.orders = [];
      this.$store.commit('openLoading');
      const res = await this.getData();
      this.orders = res.data.list;
      this.total = res.data.total;
      this.$store.commit('closeLoading');
    },
    getData() {
      return this.$http.post('html/user/myOrder', {
        page: this.page,
        page_size: this.pageSize,
        type: this.type,
      });
    },
  },
};
</script>

<style>

</style>
